import { type ProviderData, useAuth } from 'components/Auth';
import { CIReferralDecisionModal } from 'components/CriticalIncident/components/CIReferralDecisionModal';
import { type CIReferral } from 'components/CriticalIncident/interfaces';
import { Button } from 'components/Shared/Inputs';
import { type FC, useState } from 'react';

export interface WorkOrderCellProps {
    referral: CIReferral;
}

export const WorkOrderCell: FC<WorkOrderCellProps> = ({ referral }) => {
    const { effectiveProviderData = {} as ProviderData } = useAuth();
    const [selectedReferralId, setSelectedReferralId] = useState<string | null>(null);

    const handleClose = () => {
        setSelectedReferralId(null);
    };

    return (
        <>
            <Button variant="inline" onClick={() => setSelectedReferralId(referral.referralId)}>
                {referral.externalWorkOrderId}
            </Button>
            {selectedReferralId === referral.referralId && (
                <CIReferralDecisionModal
                    open={true}
                    onClose={handleClose}
                    providerId={effectiveProviderData!.providerId}
                    referralId={referral.referralId}
                />
            )}
        </>
    );
};
